import React from 'react';

/** Insignias cosméticas equipadas (distintas de ranking / Partner). */
export default function CosmeticBadgesRow({ badges, style = {} }) {
  const list = Array.isArray(badges) ? badges : [];
  if (!list.length) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, ...style }}>
      {list.map(b => (
        <span
          key={b.slug}
          title={b.description || b.label}
          style={{
            padding: '3px 9px',
            borderRadius: 999,
            fontSize: 9,
            fontWeight: 600,
            border: '0.5px solid rgba(123,111,240,0.45)',
            color: '#b8aeff',
            background: 'rgba(83,74,183,0.18)',
          }}
        >
          {b.label}
        </span>
      ))}
    </div>
  );
}
